// src/store.js
import Vue from "vue";
import Vuex from "vuex";
import { isCouponValid } from './components/Signup-dat';
import { validateEmailBegin, processConfCode, resendConfCode } from "./components/Signup-lib";
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);
const store = new Vuex.Store({
    strict: true,
    state: {        // Establish opening state for root-level objects that need to be reactive
        mainPage: 1,
        signupFormData: {
            // email: 'trxn.jd@gmail.com',
            planClass: 1,
            billFreq: "M",
            loginCount: 2,
            submitCount: 0,
            viewPage: 1,
            cardDetail: {
            },
            couponCode: ''
        },
        timeoutPageData: {
            complete: false
        },
        cognitoProfile: {
        },
        cardErrorState: false,
        emailValidationLock: false
    },
    actions: {
        UPDATE_COUNTRY: function ({ commit, state }, country) {
            commit("SIGNUP_FORM", { country });
            if (!country) {
                commit("SIGNUP_FORM", { province: null });
            }
            let curProv = state.signupFormData.province;
            if (curProv && (curProv["country-id"] !== country.key)) {
                commit("SIGNUP_FORM", { province: null });
            }
        },
        choosePlan: function ({ commit, state }, planArg) {
            // When Plan changes, we also need to check if a coupon is in play, and whether it would
            //  become no longer valid.
            const dataChange = { planClass: planArg };
            if (state.signupFormData.couponCode && (!isCouponValid(state.signupFormData.couponCode, planArg, state.signupFormData.billFreq))) {
                dataChange.couponCode = null;
            }
            commit("SIGNUP_FORM", dataChange);
        },
        changeBillFreq({ commit, state }, newFreqVal) {
            // When BillFreq changes, we also need to check if a coupon is in play, and whether it would
            //  become no longer valid.
            const dataChange = { billFreq: newFreqVal };
            if (state.signupFormData.couponCode && (!isCouponValid(state.signupFormData.couponCode, state.signupFormData.planClass, newFreqVal))) {
                dataChange.couponCode = null;
            }
            commit("SIGNUP_FORM", dataChange);
        },
        VALIDATE_EMAIL_BEGIN: function ({ commit, state }) {
            // console.log("Actioning a Validate Email request");
            if (state.emailValidationLock) {
                return;
            }
            commit("EV_LOCK", true);
            validateEmailBegin();
        },
        PROCESS_CONF_CODE: function ({ commit }, confCode) {
            return processConfCode(confCode);
        },
        // ##TODO. Check if things like this need to be an Action
        RESEND_CONF_CODE: function () {
            resendConfCode();
        },
        CREDIT_CARD_DETAIL: function ({ commit }, cardChange) {
            // When changing credit card info, also check to clear error state
            commit("CARD_ERROR_STATE", false);
            commit("CREDIT_CARD_DETAIL", cardChange);
        },
        clearForm({ commit }) {
            commit('SIGNUP_FORM', {
                submitCount: 0,
                cardDetail: {},
                couponCode: '',
                firstName: '',
                lastName: '',
                email: '',
                company: '',
                addr1: '',
                addr2: '',
                city: '',
                postal: '',
                country: undefined,
                province: undefined
            });
            commit("COGNITO_PROFILE", {
                email_verified: undefined,
                sub: undefined,
                emailIsAvailable: undefined
            });            
        }
    },
    mutations: {
        SIGNUP_FORM: function (state, formData) {
            state.signupFormData = { ...state.signupFormData, ...formData };
        },
        SIGNUP_FORM_SUBMIT_COUNT: function (state, incr) {
            state.signupFormData.submitCount = (state.signupFormData.submitCount || 0) + incr;
        },
        SIGNUP_FORM_PAGE: function (state, pNum) {
            // console.log(" mutate page ");
            state.signupFormData.viewPage = pNum;
        },
        COGNITO_PROFILE: function (state, cognitoData) {
            state.cognitoProfile = { ...state.cognitoProfile, ...cognitoData };
        },
        CARD_ERROR_STATE: function (state, eState) {
            state.cardErrorState = eState;
        },
        CREDIT_CARD_DETAIL: function (state, cardChange) {
            let oldState = state.signupFormData.cardDetail;
            state.signupFormData.cardDetail = { ...oldState, ...cardChange };
        },
        SET_TIMEOUT_COMPLETE: function (state, pComplete) {
            state.timeoutPageData.complete = pComplete;
        },
        SET_MAIN_PAGE: function (state, pPage) {
            state.mainPage = pPage;
        },
        EV_LOCK: function (state, val) {
            state.emailValidationLock = val;
        }
    },
    getters: {
        emailIsVerified: state => {
            return (state.cognitoProfile.email_verified === "true");
        },
        emailIsValidatedAndAvailable: state => {
            return ((state.cognitoProfile.email_verified === "true") && (state.cognitoProfile.emailIsAvailable === "true"));
        },
        emailValidationLock: state => {
            return (state.emailValidationLock);
        }
    },
    plugins: [
        new VuexPersistence({
            storage: window.sessionStorage
        }).plugin
    ]
});

export default store;



// WEBPACK FOOTER //
// ./src/store.js